module.exports = __webpack_public_path__ + "img/2-2.b627aec5.jpg";